import React from 'react';
import {render} from 'react-dom';
import injectTapEventPlugin from 'react-tap-event-plugin';

// ROUTES
import Main from './components/main';

// GENERAL
import OpenHours from './routes/general/openHours';
import Login from './routes/general/login';
import LoanSetting from './routes/general/LoanSetting';
import PostalCodes from './routes/general/PostalCodes';

// TRAILERS
import Trailers from './routes/trailers/trailers';
import TrailerTypes from './routes/trailers/trailerTypes';
import TrailersInactive from './routes/trailers/trailers.inactive';
import AxlesNumbers from './routes/trailers/axlesNumbers';
import SuspensionTypes from './routes/trailers/suspensionTypes';
import BackDoors from './routes/trailers/backDoors';
import BreakTypes from './routes/trailers/breakTypes';
import Charges from './routes/trailers/charges';
import Colors from './routes/trailers/colors';
import CorrosionShields from './routes/trailers/corrosionShields';
import Floors from './routes/trailers/floors';
import FloorStructures from './routes/trailers/floorStructures';
import Fronts from './routes/trailers/fronts';
import Heights from './routes/trailers/heights';
import Lengths from './routes/trailers/lengths';
import Lights from './routes/trailers/lights';
import Makes from './routes/trailers/makes';
import Models from './routes/trailers/models';
import Roofs from './routes/trailers/roofs';
import RoofStructures from './routes/trailers/roofStructures';
import SideDoors from './routes/trailers/sideDoors';
import States from './routes/trailers/states';
import TieTypes from './routes/trailers/tieTypes';
import WallStructures from './routes/trailers/wallStructures';
import Waranties from './routes/trailers/waranties';
import Wheels from './routes/trailers/wheels';
import Widths from './routes/trailers/widths';
import Flags from './routes/trailers/flags';
import Walls from './routes/trailers/walls';
import StoneShields from './routes/trailers/stoneShields';
import KijijiRegions from './routes/trailers/kijijiRegions';
import KijijiTotalBudgets from './routes/trailers/kijijiTotalBudgets';
import KijijiDailyBudgets from './routes/trailers/kijijiDailyBudgets';
import KijijiCPC from './routes/trailers/kijijiCPC';
import TrailersKijiji from './routes/trailers/trailers.kijiji';
import StandardHardwares from './routes/trailers/standardHardwares';
import DoorRestraints from './routes/trailers/doorRestraints';
import TrailersLesPAC from './routes/trailers/trailers.lesPAC';

// Quotes
import Quotes from './routes/quotes/quotes';
import QuotesInactive from './routes/quotes/quotes.inactive';

// Reports
import InventoryReport from './reports/inventory';
import InventoryByMakeReport from './reports/inventoryByMake';

import { Router, Route, hashHistory } from 'react-router'

injectTapEventPlugin();

render((
  <Router history={hashHistory}>
    <Route path="/" component={Main}>
      <Route path="openhours" component={OpenHours}/>
      <Route path="loansetting" component={LoanSetting}/>
      <Route path="postalcodes" component={PostalCodes}/>

      <Route path="trailers" component={Trailers}/>
      <Route path="trailertypes" component={TrailerTypes}/>
      <Route path="trailersinactive" component={TrailersInactive}/>
      <Route path="axlesnumbers" component={AxlesNumbers}/>
      <Route path="suspensiontypes" component={SuspensionTypes}/>
      <Route path="backdoors" component={BackDoors}/>
      <Route path="breaktypes" component={BreakTypes}/>
      <Route path="charges" component={Charges}/>
      <Route path="colors" component={Colors}/>
      <Route path="corrosionshields" component={CorrosionShields}/>
      <Route path="floors" component={Floors}/>
      <Route path="floorstructures" component={FloorStructures}/>
      <Route path="fronts" component={Fronts}/>
      <Route path="heights" component={Heights}/>
      <Route path="lengths" component={Lengths}/>
      <Route path="lights" component={Lights}/>
      <Route path="makes" component={Makes}/>
      <Route path="models" component={Models}/>
      <Route path="roofs" component={Roofs}/>
      <Route path="roofstructures" component={RoofStructures}/>
      <Route path="sidedoors" component={SideDoors}/>
      <Route path="states" component={States}/>
      <Route path="tietypes" component={TieTypes}/>
      <Route path="wallstructures" component={WallStructures}/>
      <Route path="waranties" component={Waranties}/>
      <Route path="wheels" component={Wheels}/>
      <Route path="widths" component={Widths}/>
      <Route path="flags" component={Flags}/>
      <Route path="walls" component={Walls}/>
      <Route path="stoneshields" component={StoneShields}/>
      <Route path="kijijiregions" component={KijijiRegions}/>
      <Route path="kijijitotalbudgets" component={KijijiTotalBudgets}/>
      <Route path="kijijidailybudgets" component={KijijiDailyBudgets}/>
      <Route path="kijijicpc" component={KijijiCPC}/>
      <Route path="trailerskijiji" component={TrailersKijiji}/>
      <Route path="trailersLesPAC" component={TrailersLesPAC}/>
      <Route path="standardhardwares" component={StandardHardwares}/>
      <Route path="doorrestraints" component={DoorRestraints}/>

      <Route path="quotes" component={Quotes}/>
      <Route path="quotesinactive" component={QuotesInactive}/>

      <Route path="inventoryreport" component={InventoryReport}/>
      <Route path="inventorybymakereport/:makeid" component={InventoryByMakeReport}/>
    </Route>
    <Route path="/login" component={Login}/>
  </Router>
), document.getElementById('app'));



/** WEBPACK FOOTER **
 ** ./src/app/app.js
 **/